import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Key } from "lucide-react";
import Alert from "../../components/alert";
import Footer from "../../components/footer";
import Navbar from "../../components/navbar";
import { ChedaGamingForm } from "../../components/form/cheda-gaming-form";
import ChedaGamingInput from "../../components/form/cheda-gaming-input";
import ChedGamingButton from "../../components/cheda-gaming-button";
import * as Yup from "yup";
import useVerifyOtp from "../../hooks/useVerifyOtp";
import "./styles/signup.css";

function VerifyOTP() {
  const location: any = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from || "signup";
  const initialEmail = location.state?.email || "";
  const initialOtp = "";

  const [alert, setAlert] = useState<any | null>(null);

  const showAlert = (type: any, message: string, title: string | null = null) =>
    setAlert({ type, message, title });
  const hideAlert = () => setAlert(null);

  const { handleSubmit, handleResend, loading, cooldown } = useVerifyOtp({
    from,
    initialEmail,
    showAlert,
    navigate,
  });

  return (
    <div className="signup-page page-with-navbar-footer">
      <Navbar />

      <div className="signup-background">
        <div className="background-overlay"></div>
      </div>

      <div className="signup-container">
        <div className="signup-card">
          <div className="signup-header">
            <div className="logo-container">
              <img
                src="/images/chedagaming_logo.png"
                alt="Cheda Gaming"
                className="signup-logo"
              />
            </div>
            <h1 className="signup-title">Verify OTP</h1>
            <p className="signup-subtitle">
              {from === "signup"
                ? `Enter the OTP sent to ${initialEmail} to verify your account`
                : `Enter the OTP sent to ${initialEmail} to continue password reset`}
            </p>
          </div>

          <ChedaGamingForm
            initialValues={{ email: initialEmail, otp: initialOtp }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email("Invalid email")
                .required("Email is required"),
              otp: Yup.string().required("OTP is required"),
            })}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <>
                <ChedaGamingInput
                  name="otp"
                  label="OTP"
                  placeholder="Enter OTP"
                  required
                  onChange={formik.handleChange}
                  icon={<Key className="input-icon" size={20} />}
                  onBlur={formik.handleBlur}
                  value={formik.values.otp}
                  touched={!!formik.touched.otp}
                  error={formik.errors.otp as string | undefined}
                  disabled={formik.isSubmitting || loading}
                />

                <div className="otp-actions">
                  <ChedGamingButton
                    type="submit"
                    className="signup-button"
                    loading={formik.isSubmitting || loading}
                    disabled={formik.isSubmitting || loading || !initialEmail}
                  >
                    Verify OTP
                  </ChedGamingButton>
                  <button
                    type="button"
                    className="resend-link"
                    onClick={handleResend}
                    disabled={
                      formik.isSubmitting ||
                      loading ||
                      cooldown > 0 ||
                      !initialEmail
                    }
                  >
                    {cooldown > 0 ? `Resend OTP (${cooldown}s)` : "Resend OTP"}
                  </button>
                </div>
              </>
            )}
          </ChedaGamingForm>

          <div className="login-section">
            <p className="login-text">
              Need help?{" "}
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="login-link"
              >
                Contact Support
              </button>
            </p>
          </div>
        </div>
      </div>

      <Footer />

      {alert && (
        <Alert
          type={alert.type}
          title={alert.title}
          message={alert.message}
          onClose={hideAlert}
          duration={5000}
          position="top-right"
        />
      )}
    </div>
  );
}

export default VerifyOTP;
